import React from 'react';
import SupplierQuestionnaire from '../modules/supplier-assessment/SupplierQuestionnaire';

export default function SupplierPortalQuestionnaire() {
  return <SupplierQuestionnaire />;
}
